import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { useEffect, useRef } from 'react';
import { TUpdate } from 'domain/types';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { useContextSelector as useCS } from 'use-context-selector';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import { showSystemToast } from 'view/components/SystemToast';
import { useAuthMe } from 'view/pages/auth/hooks/useAuthMe';

export const useUpdateJobSeekerPreferences = (): any => {
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );
  const silentRef = useRef(false);

  const { send: authMe } = useAuthMe(false);

  const { data, isLoading, status, error, send } = useRequest({
    url: '/api/v1/profile/jobSeeker',
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
    body: {},
  });

  const updateJobSeekerPreferences = (formData: any, silent = false) => {
    silentRef.current = silent;
    const dataToSend = {
      industry: formData.industry,
      jobCategory: formData.jobCategory,
      jobTitle: formData.jobTitle,
      positionType: formData.positionType,
      salaryMin: Number(formData.salaryRange.from),
      salaryMax: Number(formData.salaryRange.to),
      location: formData.jobLocation,
      jobLocation: {
        onSite: formData.onSite,
        remote: formData.remote,
        hybrid: formData.hybrid,
      },
      languages: formData.languages,
      workExperience: formData.workExperience,
      education: formData.education,
      certificates: formData.certificates,
      qualifications: formData.qualifications,
      skills: formData.skills,
      hasWorkPreferencesFilled: true,
    };
    return send(dataToSend);
  };

  useEffect(() => {
    if (isLoading || !data) return;
    update?.({ jobSeekerPreferencesData: data });
    authMe();
    if (!silentRef.current) {
      showSystemToast(
        'success',
        'Work Preferences Updated',
        'Your changes have been saved successfully.'
      );
    }
  }, [data, isLoading, update]);

  return {
    isLoading,
    error: error || null,
    updateJobSeekerPreferences,
    status,
  };
};
